import React, { useCallback, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { InputSearch, Button } from 'Components';
import { Grid, Typography } from '@mui/material';
import Checkbox from 'Components/Checkbox';
import { MenuComponent } from 'Components/Menu';

import QuickMesssageEdit from './components/createEdit';
import QuickDelete from './components/delete';

import './index.scss';
import Loading from 'Components/Loading';

import {
    searchQuickMessage,
    openQuickMessageCreateEdit,
    openQuickMessageDelete
} from 'Redux/actions';

const QuickMessage = (props) => {
    //const
    const { messages } = useIntl();

    const dispatch = useDispatch();
    const [selectedRows, setSelectedRows] = useState([]);
    const [filter, setFilter] = useState('');
    const [data, setData] = useState([]);
    //Selectors
    const {
        loadingQuickMessage,
        quickMData
    } = useSelector(state => state.quickMessageRedux);

    useEffect(() => {
        dispatch(searchQuickMessage());
    }, []);

    useEffect(() => {
        const newFilter = filter.length > 0?quickMData?.filter((item) => item.name.toLowerCase().includes(filter.toLowerCase())):quickMData
        setData(newFilter);
    }, [quickMData]);

    const onSearch = useCallback((value) => {
        setFilter(value);
        const newFilter = quickMData?.filter((item) => item.name.toLowerCase().includes(value.toLowerCase()))
        setData(newFilter);
    });

    const callBack = useCallback(() => {
        setFilter('');
        setSelectedRows([])
    });

    return (
        <div>
            <Grid container spacing={0}>
                <Grid item sm={12}>
                    <InputSearch
                        searchText={filter}
                        onSearch={(param) => onSearch(param)}
                    />
                </Grid>
            </Grid>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
                style={{ paddingTop: 10 }}
            >
                <Grid item xs>
                    <Button
                        type="icon"
                        icon="add_box"
                        tooltip={messages['add']}
                        onClick={() => {
                            dispatch(openQuickMessageCreateEdit(true))
                        }}
                    />
                    <Button
                        type="icon"
                        icon="delete"
                        disabled={!selectedRows?.length}
                        tooltip={messages['delete']}
                        onClick={() => {
                            dispatch(openQuickMessageDelete(true, selectedRows))
                        }}
                    />
                </Grid>
                <Grid item xs className='text-right'>
                    {
                        data?.length > 0 &&
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center"
                        >
                            <Grid item>
                                <Checkbox
                                    id={'quick-message-form-select-all'}
                                    value={data?.length === selectedRows.length}
                                    className='allSelection-checkbox'
                                    onChange={(checked) => {
                                        if (checked) {
                                            setSelectedRows(data);
                                        } else {
                                            setSelectedRows([]);
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item>
                                <Button
                                    className="btn-cancel btn-sm"
                                    style={{
                                        color: '#333333'
                                    }}
                                    onClick={(e) => {
                                        if (e) e.preventDefault();
                                        if (selectedRows?.length === data?.length) {
                                            setSelectedRows([]);
                                        } else {
                                            setSelectedRows(data);
                                        }

                                    }}
                                >
                                    {messages['fsm_settings_form_selectAll']}
                                </Button>
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </Grid>
            <div
                style={{
                    height: "calc(100vh - 350px)",
                    overflow: "auto"
                }}
            >
                <Grid
                    container
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                >
                    {loadingQuickMessage &&
                        <Loading full />
                    }
                    {
                        data?.length > 0 && data?.map((row, index) => {
                            let selected = selectedRows.find(selectedRow => selectedRow.id === row.id);

                            return (
                                <Grid
                                    key={index}
                                    item xs
                                    style={{ width: '100%', margin: 0 }}
                                >
                                    <div style={{ padding: '5px 4px 8px 3px' }}>
                                        <div className={"QuickMessageView-card QuickMessageView-container"}>
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="flex-start"
                                                alignItems="center"
                                            >
                                                <Grid item>
                                                    <Checkbox
                                                        id={`fsm-quick-${row?.id}`}
                                                        value={selected ? true : false}
                                                        className='label-no-margin'
                                                        size="sm"
                                                        onChange={(checked) => {

                                                            let newSelectedRows = [];
                                                            if (checked) {
                                                                newSelectedRows = [...selectedRows];
                                                                newSelectedRows.push(row);
                                                            } else {
                                                                newSelectedRows = selectedRows.filter(selectedRow => selectedRow.id !== row.id);
                                                            }

                                                            setSelectedRows([...newSelectedRows]);
                                                        }}
                                                    ></Checkbox>
                                                </Grid>

                                                <Grid item>
                                                    <Typography
                                                        noWrap
                                                        variant="subtitle1"
                                                        className="formSetting-title"
                                                    >
                                                        {row?.name}
                                                    </Typography >
                                                </Grid>

                                                <Grid item >
                                                    <MenuComponent
                                                        icon={'more_vert'}
                                                        options={[
                                                            messages['edit'],
                                                            messages['delete']
                                                        ]}
                                                        className="formSetting-actions icon-menu-vehicle-service showInHover"
                                                        onClick={(type) => {
                                                            if (type === messages['edit']) {
                                                                dispatch(openQuickMessageCreateEdit(true, row))
                                                            } else {
                                                                dispatch(openQuickMessageDelete(true, [row]))

                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </div>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </div>

            <QuickMesssageEdit />
            <QuickDelete callBack={callBack} />
        </div>
    );
}

export default QuickMessage;